<template>
  <imgBorderContainer
    :title="`他在參與${detail.type_cn || ''}評選`"
    class="company-img-border"
  >
    <div class="company-container-wrapper">
      <div class="company-head">
        <div class="left">
          <div class="logo">
            <img :src="detail.logo" alt="" />
          </div>
          <div class="c-name text-ellipsis-2" :title="detail.service_name">
            {{ detail.service_name }}
          </div>
        </div>
        <div class="center">
          <div class="c-vote text-num">
            <div class="text">票數</div>
            <div class="num">{{ detail.votes }}</div>
          </div>
          <div class="c-rank text-num">
            <div class="text">排名</div>
            <div class="num">{{ detail.rank }}</div>
          </div>
        </div>
        <div class="right">
          <div class="c-op">
            <div
              :style="{ pointerEvents: voteLoading ? 'none' : '' }"
              class="c-op-btn black"
              @click="handleVoteMixin(detail.type, $route.params.id)"
            >
              投&nbsp;票
            </div>

            <share :companyId="detail.company_id"
              ><div class="c-op-btn">為他拉票</div></share
            >
          </div>
        </div>
      </div>
      <div class="company-foot">
        <div class="btn-mobile">
          <div
            :style="{ pointerEvents: voteLoading ? 'none' : '' }"
            class="c-op-btn black"
            @click="handleVoteMixin(detail.type, $route.params.id)"
          >
            投&nbsp;票
          </div>

          <share :companyId="$route.params.id"
            ><div class="c-op-btn">為他拉票</div></share
          >
        </div>
      </div>
    </div>
  </imgBorderContainer>
</template>
<script>
import imgBorderContainer from "@/components/imgBorderContainer";
import loadingComponent from "@/components/loadingComponent";
import voteMixin from "@/mixins/vote";
import share from "@/components/share";
export default {
  mixins: [voteMixin],
  components: { imgBorderContainer, loadingComponent, share },
  data() {
    return {
      loading: false,
      voteLoading: false,
    };
  },
  props: ["detail"],
};
</script>
<style lang="less">
@import "~@/assets/styles/var.less";

.company-img-border {
  .img-border-btn {
    font-size: 24px;
    padding: 20px 100px 30px;
    @media (max-width: 768px) {
      font-size: 16px;
      padding: 10px 60px 20px;
    }
  }
}
.company-container-wrapper {
  color: #fff;
  background: linear-gradient(0deg, #cc9578 0%, #ffdbb9 100%);
  border-radius: 10px;
  padding: 80px 60px 30px;
  font-size: 30px;

  overflow: hidden;
  @media (max-width: 768px) {
    padding: 80px 10px 10px;
    font-size: 14px;
  }
}
.company-head {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .left {
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 50%;
    // @media (max-width: 768px) {
    //   flex-direction: column;
    // }
    .logo {
      width: 140px;
      height: 140px;
      border-radius: 50%;
      background: #ddd;
      overflow: hidden;
      flex-shrink: 0;
      border: 2px solid #fff;
      box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.3);
      @media (max-width: 768px) {
        width: 50px;
        height: 50px;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .c-name {
      margin-left: 20px;
      text-shadow: 2px 4px 2px #b99381;
      font-weight: bold;
      // @media (max-width: 768px) {
      //   text-align: center;
      //   margin: 0;
      // }
    }
  }
  .center {
    display: flex;
    font-family: Source Han Sans CN Bold, Source Han Sans CN Bold-Bold;
    .text-num {
      font-weight: bold;
      .text {
        padding-bottom: 10px;
        text-shadow: 2px 4px 2px #b99381;
      }
      .num {
        text-shadow: 2px 4px 2px #b99381;
      }
    }
    .c-vote {
      margin-right: 40px;
      text-align: center;
      @media (max-width: 768px) {
        margin-right: 10px;
      }
    }
    .c-rank {
      text-align: center;
      margin-left: 40px;
      @media (max-width: 768px) {
        margin-right: 10px;
      }
    }
  }
  .right {
    font-size: 18px;
    color: #fff;

    @media (max-width: 768px) {
      font-size: 12px;
      display: none;
    }
    .c-op {
      .c-op-btn {
        min-width: 180px;
        min-height: auto;
        border: 5px solid #fdd9b7;
        border-radius: 30px;
        text-align: center;
        padding: 8px 0;
        color: @black;
        background: #cd9779;
        box-shadow: 5px 5px 0px 0px #7b5b51;
        cursor: pointer;
        // @media (max-width: 768px) {
        //   min-width: 80px;
        //   border: 2px solid #fdd9b7;
        //   box-shadow: 2px 2px 0px 0px #7b5b51;
        // }
        &.black {
          margin-bottom: 20px;
          background: #323345;
          color: @yellow;
        }
      }
    }
  }
}
.btn-mobile {
  display: flex;
  font-size: 14px;
  margin-top: 20px;
  justify-content: space-around;

  display: none;
  @media (max-width: 768px) {
    display: flex;
  }
  .c-op-btn {
    min-width: 100px;
    min-height: auto;
    border: 2px solid #fdd9b7;
    border-radius: 30px;
    text-align: center;
    padding: 8px 0;
    color: @black;
    background: #cd9779;
    box-shadow: 2px 2px 0px 0px #7b5b51;
    cursor: pointer;
    &.black {
      background: #323345;
      color: @yellow;
    }
  }
}
</style>